export default {
  drawer: true,
}
